export default __webpack_public_path__ + "static/media/Athena-light.f378288e.gif";